import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-239ea64c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  key: 0,
  class: "inner"
}
const _hoisted_3 = { class: "label" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Souhlasím s ")
const _hoisted_5 = ["href"]

import { useField } from 'vee-validate'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { VUE_APP_CONSENT_URL } = process.env

const { checked, handleChange } = useField('consent', undefined, {
  type: 'checkbox',
  checkedValue: true,
  uncheckedValue: false,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "outer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleChange)(!_unref(checked)))),
      tabindex: "3"
    }, [
      (_unref(checked))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("a", {
        href: _unref(VUE_APP_CONSENT_URL),
        tabindex: "5",
        target: "_blank"
      }, "podmínkami souteže a se zpracováním osobních údajů", 8, _hoisted_5)
    ])
  ]))
}
}

})